import Flickity from 'flickity';
require('flickity-imagesloaded');

const MOBILE_BREAKPOINT = 940;

function initTimelineSlider(element) {
  const container = element.querySelector('.timeline__strip');
  if (!container || element.flickity) return;

  element.flickity = new Flickity(container, {
    prevNextButtons: true,
    pageDots: false,
    contain: true,
    groupCells: 1,
    cellAlign: 'left',
    imagesLoaded: true,
  });

  element.classList.add('timeline--has-flickity');
}

function destroyTimelineSlider(element) {
  if (element.flickity) {
    element.flickity.destroy();
    element.flickity = null;
  }

  element.classList.remove('timeline--has-flickity');
}

export default function timelineSlider() {
  const elements = document.querySelectorAll('[data-timeline-slider]');

  function update() {
    const isDesktop = window.innerWidth > MOBILE_BREAKPOINT;

    elements.forEach((element) => {
      if (isDesktop) {
        initTimelineSlider(element);
      } else {
        destroyTimelineSlider(element);
      }
    });
  }

  update();
  window.addEventListener('resize', update);
}
